import { quickEntries } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function QuickEntries() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-bold tracking-[0.3em] text-primary-600 md:text-sm">OVERVIEW</span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
                事件速览 · 从这里进入
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
              把零散信息整理成一条条清晰入口，想先看结论、先看时间线还是先看热度榜，都由你决定。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-12 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {quickEntries.map((entry, index) => (
            <Reveal key={entry.title} delay={index * 60}>
              <a
                href={entry.href}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300 hover:bg-background-50 md:p-6"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600 md:h-12 md:w-12">
                    <i className={`${entry.icon} text-xl md:text-2xl`} />
                  </span>
                  <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                    {entry.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {entry.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
                <span className="mt-5 flex items-center gap-1 text-sm font-semibold text-primary-600">
                  立即进入
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}